document.addEventListener('DOMContentLoaded', function() {
  // console.log('Kaching Bundles Extension Custom JS loaded');
  const bars = document.querySelectorAll('.kaching-bundles__bar');
  const quantityInput = document.querySelector('input[type="hidden"][name="quantity"]');
  const portionElement = document.querySelector('.preis-pro-portion-v2');
  let currentPortion = null;
  let currentQuantity = 1;
  let currentSalePrice = null;

  function updatePricePerPortion() {
    if (!portionElement || bars.length === 0) return;

    const form = document.querySelector('form.kaching-bundles-form--different-variants-selected');
    if (form) {
      const barsContainer = form.querySelector('.kaching-bundles__bars');
      if (barsContainer) {
        const selectedBar = barsContainer.querySelector('.kaching-bundles__bar--selected');
        if (selectedBar) {
          currentQuantity = Array.from(barsContainer.children).indexOf(selectedBar) + 1;
          // console.log('currentQuantity aus ausgewähltem Bar:', currentQuantity);
        }
      }
    } else {
      currentQuantity = parseInt(quantityInput?.value) || 1;
      // console.log('Aktueller quantity-Wert:', currentQuantity);
    }

    currentPortion = parseFloat(portionElement.getAttribute('data-portionen')) || 0;
    // console.log('Aktueller data-portionen Wert:', currentPortion);

    const portionSum = currentPortion * currentQuantity;
    // console.log('Aktueller portionSum-Wert:', portionSum);

    const barIndex = currentQuantity - 1;
    if (bars[barIndex]) {
      currentSalePrice = parseFloat(
        bars[barIndex].querySelector('.kaching-bundles__bar-price')
        .textContent.replace(/[^0-9,.]/g, '').replace(',', '.')
      );
      // console.log('Aktueller Sale Price aus Bar Index:', currentSalePrice);
    }

    if (!isNaN(currentSalePrice) && currentSalePrice > 0 && portionSum > 0) {
      const pricePerPortion = currentSalePrice / portionSum;
      const priceFormatted = pricePerPortion.toFixed(2).replace('.', ',');
      // console.log('Preis pro Portion:', priceFormatted);

      const targetDiv = document.querySelector('#preis-pro-portion-text');
      if (targetDiv) {
        targetDiv.textContent = `€${priceFormatted} / Portion`;
      }
    }
  }

  if (quantityInput) {
    const observer = new MutationObserver(updatePricePerPortion);
    observer.observe(quantityInput, { attributes: true, attributeFilter: ['value'] });
  }

  updatePricePerPortion();
  window.updatePricePerPortion = updatePricePerPortion;
});
